import BaseRequest from '../_baseRequest';

const baseUrl = 'Report/ReportByUrl';
const baseUrlDownload = 'Report/DownloadByUrl';

const DownloadService = {
  getAreas: () => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: 'area_dwn_type_web_lov' },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  getMacro: (categoria) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `area_dwn_type_macrotema_web?ptipodwnl=${categoria}` },
      null,
      'post',
      `/api/${baseUrl}`,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  getAreaDetails: (tipoDownload, macro) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `area_dwn_type_tema_web?ptipodwnl=${tipoDownload}&pmacrotema=${macro}` },
      null,
      'post',
      `/api/${baseUrl}`,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  getPeriods: (tipoDownload, macro, tema) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `area_dwn_type_file_web?ptipodwnl=${tipoDownload}&pmacrotema=${macro}&ptema=${tema}` },
      null,
      'post',
      `/api/${baseUrl}`,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  getReportEvidenza: () => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: 'homepage_report_evidenza' },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  },

  getReportConsultati: () => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: 'homepage_report_consultati' },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  },

  getGeneratedFileParams: (format, date, funzione) => {
    let url;
    if (date[1] === undefined) {
      url = `reportspooldownload?pfun=${funzione}&haRuolo&pdata=${date[0]}&poffset=&pnext=&p_filter_field=&p_filter_value=&pdoctype=${format}`;
    } else {
      url = `reportspooldownload?pfun=${funzione}&haRuolo&pdatada=${date[0]}&pdataa=${date[1]}&poffset=1&pnext=100&p_filter_field=&p_filter_value=&p_orderby_field=&p_orderby_direct=&pdoctype=${format}`;
    }

    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  },

  getGeneratedFileParamsTable: (format, data, funzione, filtri, ordine) => {
    const url = `reportspooldownload?pfun=${funzione}&prole=1&pdata=${data}&poffset=&pnext=&p_filter_field=${filtri[0]}&p_filter_value=${filtri[1]}&p_orderby_field=${ordine[0]}&p_orderby_direct=${ordine[1]}&pdoctype=${format}`;
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  },

  downloadFile: (param) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: param },
      null,
      'get_file',
      '/api/' + baseUrlDownload,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  }
};
export default DownloadService;
